import { forwardRef, type MouseEvent } from 'react';

import { Calendar, Close } from '@air/next-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Input, type InputProps } from '@air/primitive-input';
import { cn } from '@air/utils-tailwind';

export type DateInputFieldProps = {
  onClear?: (e: MouseEvent<HTMLButtonElement>) => void;
  showCalendarIcon?: boolean;
} & InputProps;

export const DateInputField = forwardRef<HTMLInputElement | null, DateInputFieldProps>(
  ({ showCalendarIcon = true, className, size, onClear, ...props }: DateInputFieldProps, ref) => {
    const showClearIcon = !!onClear && !!props.value;

    return (
      <div className="relative flex">
        {showCalendarIcon && <Calendar className="absolute top-1/2 left-3 size-4 -translate-y-1/2 text-grey-11" />}
        <Input
          className={cn('w-full', showCalendarIcon ? 'pl-9' : '', showClearIcon ? 'pr-8' : '', className)}
          ref={ref}
          size={size}
          {...props}
        />
        {showClearIcon && (
          <IconButton
            appearance="ghost"
            className="absolute top-1/2 right-1.5 -translate-y-1/2"
            color="grey"
            icon={Close}
            label="Clear"
            onClick={onClear}
            size="small"
          />
        )}
      </div>
    );
  },
);

DateInputField.displayName = 'DateInputField';
